import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearnSchool = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 20,
	viewBox: "-0.5 -0.5 26 19.6727",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M24.5 5.3L12.5 0.5L0.5 5.3L12.5 10.1L24.5 5.3ZM24.5 5.3V12.5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.86364 7.04545V14.6819C4.86364 15.5499 5.55325 16.3823 6.78076 16.9961C8.00827 17.6098 10.764 18.1727 12.5 18.1727C14.6818 18.1726 16.9917 17.6098 18.2192 16.9961C19.4468 16.3823 20.1364 15.5499 20.1364 14.6819V7.04545L12.5 10.1001L4.86364 7.04545Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLearnSchool;
